// function sliderLazyLoad() {
//     // let triggers = [...document.querySelectorAll('.lazy-trigger')]
//     let images = [...document.querySelectorAll('.slider-front .wrp__lazyload')]
//     const interactSettings = {
//         Document: null,
//         rootMargin: '0px 0px 1000px 0px',
//         threshold: 0
//     }
//
//     function onIntersection(imageEntites) {
//         imageEntites.forEach(image => {
//             if (image.isIntersecting) {
//                 observer.unobserve(image.target)
//                 // let parentDiv =image.target.closest('.image-parent-wrapper') ;
//                 image.target.classList.add('wrp__lazyloaded')
//                 Array.from(image.target.querySelectorAll('img')).forEach((item, i) => {
//                     if (i < 4) {
//                         item.src = item.dataset.src;
//                         console.log(1234)
//                         // item.srcset = item.dataset.srcset
//                         item.classList.add('lazyloaded')
//
//                     }
//                 });
//             }
//         })
//     };
//
//     let observer = new IntersectionObserver(onIntersection, interactSettings);
//     images.forEach((image) => {
//         observer.observe(image)
//     })
//     // triggers.forEach((trigger) => {
//     //     observer.observe(trigger)
//     // })
// };
//
// sliderLazyLoad();
//
// function sliderOffsetKSA() {
//     for (let l = 0; l < document.querySelectorAll('.slider-front').length; l++) {
//         const slider = document.querySelectorAll('.slider-front')[l];
//         const btnRight = slider.querySelector('.slider__next')
//         const btnLeft = slider.querySelector('.slider__prev')
//         const wrpSliderList = document.querySelectorAll('.wrap-slider-list')[l];
//         const slides = slider.querySelectorAll('.slider-item');
//         const sliderList = wrpSliderList.querySelector('.slider-list');
//         const sliderCurrenSlide = slider.querySelector('.slider__current');
//         let countSlides = 0, widthSlider, widthItem;
//         widthSlider = wrpSliderList.offsetWidth;
//         console.log( 'width', slides, 1 * slides.length + 'px')
//
//         slider.querySelector('.slider__count').innerHTML = slides.length;
//
//
//
//
//         function init() {
//             let viewItem = 1
//             if(widthSlider > 400) {
//                 viewItem = 2
//             }
//             if(widthSlider > 650) {
//                 viewItem = 3
//             }
//             widthItem = wrpSliderList.offsetWidth;
//             widthItem = widthItem / viewItem
//
//             // sliderList.style.width = width * .8 * slides.length + 'px';
//
//             sliderList.style.width = widthItem * 1 * slides.length + 'px';
//             console.log( 'width', widthItem * 1 * slides.length + 'px')
//             slides.forEach(item => {
//                 // item.style.width = (width * .8) + 'px';
//                 item.style.width = (widthItem ) + 'px';
//                 item.style.height = 'auto';
//             });
//             rollSlider();
//         }
//
//             init();
//         window.onresize = init();
//
//         window.addEventListener('resize', init);
//
//         function rollSlider() {
//             if (countSlides == slides.length - 1) {
//                 // sliderList.style.transform = 'translate(-' + ((countSlides - 1) * width * 0.8 + (width * 0.605) - 6) + 'px)';
//                 sliderList.style.transform = 'translate(-' + (countSlides * width)  + 'px)';
//             } else {
//                 // sliderList.style.transform = 'translate(-' + countSlides * width * 0.8 + 'px)';
//                 sliderList.style.transform = 'translate(-' + countSlides * width + 'px)';
//             }
//
//             console.log('countSlides', countSlides)
//             sliderCurrenSlide.innerHTML = countSlides + 1;
//         }
//
//         function left() {
//             if (countSlides > 0) {
//                 countSlides--
//                 if (countSlides == 0) {
//                     btnLeft.style.display = 'none'
//                 }
//                 btnRight.style.display = 'block'
//
//                 rollSlider();
//             }
//         }
//
//         function right() {
//             if (countSlides < slides.length - 1) {
//                 countSlides++;
//                 btnLeft.style.display = 'block'
//                 if (countSlides + 1 == slides.length) {
//                     btnRight.style.display = 'none'
//                 }
//                 loadImgSrc()
//                 rollSlider();
//             }
//         }
//
//         function loadImgSrc() {
//             if (countSlides + 2 < slides.length) {
//                 let slideImg = slides[countSlides + 2].querySelector('img')
//                 if (!slideImg.classList.contains('lazyloaded')) {
//                     slideImg.src = slideImg.dataset.src
//                 }
//             }
//         }
//
//         btnRight.style.display = 'block'
//         btnRight.addEventListener('click', function () {
//             right()
//         });
//         btnLeft.addEventListener('click', function () {
//             left()
//         });
//
//         let change = false
//         sliderList.onmousedown = function (event) {
//             change = true
//             let shiftX = event.clientX;
//
//             function moveAt(pageX) {
//                 if (shiftX - pageX > 50) {
//                     right()
//                     document.removeEventListener('mousemove', onMouseMove);
//                 }
//                 if (pageX - shiftX > 50) {
//                     left()
//                     document.removeEventListener('mousemove', onMouseMove);
//                 }
//             }
//
//             function onMouseMove(event) {
//                 moveAt(event.pageX);
//             }
//
//             document.addEventListener('mousemove', onMouseMove)
//             sliderList.onmouseup = function () {
//                 change = false
//                 document.removeEventListener('mousemove', onMouseMove);
//             };
//         };
//         slider.ondragstart = function () {
//             change = false
//             return false;
//         };
//         slider.onmousedown = function () {
//             return false;
//         };
//
//         sliderList.ontouchstart = function (event) {
//             change = true
//             let shiftX = event.touches[0].clientX;
//             moveTAt(event.pageX);
//
//             function moveTAt(pageX) {
//                 if (shiftX - pageX > 50) {
//                     right()
//                     change = false
//                 }
//                 if (pageX - shiftX > 50) {
//                     left()
//                     change = false
//                 }
//             }
//
//             function onTouchMove(event) {
//                 if (change) {
//                     moveTAt(event.touches[0].clientX);
//                 }
//             }
//
//             document.addEventListener('touchmove', onTouchMove);
//             sliderList.ontouchend = function () {
//                 document.removeEventListener('touchmove', onTouchMove);
//                 sliderList.onmouseup = null;
//             };
//         };
//     }
// }
// sliderOffsetKSA();

function sliderLazyLoad() {
    let triggers = [...document.querySelectorAll('.lazy-trigger')]
    let images = [...document.querySelectorAll('.slider__ksa .wrp__lazyload')]
    const interactSettings = {
        Document: null,
        rootMargin: '0px 0px 1000px 0px',
        threshold: 0
    }

    function onIntersection(imageEntites) {
        imageEntites.forEach(image => {
            if (image.isIntersecting) {
                observer.unobserve(image.target)
                // let parentDiv =image.target.closest('.image-parent-wrapper') ;
                image.target.classList.add('wrp__lazyloaded')
                Array.from(image.target.querySelectorAll('img')).forEach((item, i) => {
                    if (i < 4) {
                        item.src = item.dataset.src;
                        // item.srcset = item.dataset.srcset
                        item.classList.add('lazyloaded')

                    }
                });
            }
        })
    };

    let observer = new IntersectionObserver(onIntersection, interactSettings);
    images.forEach((image) => {
        observer.observe(image)
    })
    triggers.forEach((trigger) => {
        observer.observe(trigger)
    })
};

sliderLazyLoad();

function sliderOffsetKSA() {
    for (let l = 0; l < document.querySelectorAll('.slider').length; l++) {
        const slider = document.querySelectorAll('.slider')[l];
        const btnRight = slider.querySelector('.slider-btn-next')
        const btnLeft = slider.querySelector('.slider-btn-prev')
        const wrpSliderList = document.querySelectorAll('.wrap-slider-content')[l];
        const slides = slider.querySelectorAll('.slide-item');
        const sliderList = wrpSliderList.querySelector('.slider-content');
        const sliderCurrenSlide = slider.querySelector('.slider-current');
        let countSlides = 0, widthSlider, width;
        widthSlider = wrpSliderList.offsetWidth;
        slider.querySelector('.slider-count').innerHTML = slides.length;

        function init() {
            width = wrpSliderList.offsetWidth;
            // sliderList.style.width = width * .8 * slides.length + 'px';
            sliderList.style.width = width * 1 * slides.length + 'px';
            slides.forEach(item => {
                // item.style.width = (width * .8) + 'px';
                item.style.width = (width ) + 'px';
                item.style.height = 'auto';
            });
            rollSlider();
        }

        init();
        window.addEventListener('resize', init);

        function rollSlider() {
            if (countSlides == slides.length - 1) {
                // sliderList.style.transform = 'translate(-' + ((countSlides - 1) * width * 0.8 + (width * 0.605) - 6) + 'px)';
                sliderList.style.transform = 'translate(-' + (countSlides * width)  + 'px)';
            } else {
                // sliderList.style.transform = 'translate(-' + countSlides * width * 0.8 + 'px)';
                sliderList.style.transform = 'translate(-' + countSlides * width + 'px)';
            }
            sliderCurrenSlide.innerHTML = countSlides + 1;
        }

        function left() {
            if (countSlides > 0) {
                countSlides--
                if (countSlides == 0) {
                    btnLeft.style.display = 'none'
                }
                btnRight.style.display = 'block'

                rollSlider();
            }
        }

        function right() {
            if (countSlides < slides.length - 1) {
                countSlides++;
                btnLeft.style.display = 'block'
                if (countSlides + 1 == slides.length) {
                    btnRight.style.display = 'none'
                }
                loadImgSrc()
                rollSlider();
            }
        }

        function loadImgSrc() {
            if (countSlides + 2 < slides.length) {
                let slideImg = slides[countSlides + 2].querySelector('img')
                if (!slideImg.classList.contains('lazyloaded')) {
                    slideImg.src = slideImg.dataset.src
                }
            }
        }

        btnRight.style.display = 'block'
        btnRight.addEventListener('click', function () {
            right()
        });
        btnLeft.addEventListener('click', function () {
            left()
        });

        let change = false
        sliderList.onmousedown = function (event) {
            change = true
            let shiftX = event.clientX;

            function moveAt(pageX) {
                if (shiftX - pageX > 50) {
                    right()
                    document.removeEventListener('mousemove', onMouseMove);
                }
                if (pageX - shiftX > 50) {
                    left()
                    document.removeEventListener('mousemove', onMouseMove);
                }
            }

            function onMouseMove(event) {
                moveAt(event.pageX);
            }

            document.addEventListener('mousemove', onMouseMove)
            sliderList.onmouseup = function () {
                change = false
                document.removeEventListener('mousemove', onMouseMove);
            };
        };
        slider.ondragstart = function () {
            change = false
            return false;
        };
        slider.onmousedown = function () {
            return false;
        };

        sliderList.ontouchstart = function (event) {
            change = true
            let shiftX = event.touches[0].clientX;
            moveTAt(event.pageX);

            function moveTAt(pageX) {
                if (shiftX - pageX > 50) {
                    right()
                    change = false
                }
                if (pageX - shiftX > 50) {
                    left()
                    change = false
                }
            }

            function onTouchMove(event) {
                if (change) {
                    moveTAt(event.touches[0].clientX);
                }
            }

            document.addEventListener('touchmove', onTouchMove);
            sliderList.ontouchend = function () {
                document.removeEventListener('touchmove', onTouchMove);
                sliderList.onmouseup = null;
            };
        };
    }
}

sliderOffsetKSA();

// slider()
function slider () {
    const images = document.querySelectorAll('.slider .slider-line img');
    const sliderLine = document.querySelector('.slider .slider-line');
    let count = 0;
    let width;

    function init() {
        console.log('resize');
        width = document.querySelector('.slider').offsetWidth;
        sliderLine.style.width = width * images.length + 'px';
        images.forEach(item => {
            item.style.width = width + 'px';
            item.style.height = 'auto';
        });
        rollSlider();
    }

    init();
    window.addEventListener('resize', init);

    document.querySelector('.slider-next').addEventListener('click', function () {
        count++;
        if (count >= images.length) {
            count = 0;
        }
        rollSlider();
    });

    document.querySelector('.slider-prev').addEventListener('click', function () {
        count--;
        if (count < 0) {
            count = images.length - 1;
        }
        rollSlider();
    });

    function rollSlider() {
        sliderLine.style.transform = 'translate(-' + count * width + 'px)';

    }

}
